import { baseApiUrl } from "../environment/values";
import { axiosInstance as axios } from '../main';

const defaultState = () => {
    return {
        formData: {
            transactions: [],
            cbu: "",
            invoice: null,
            date: null,
            invoiceNumber: null,
            cuit: null,
            amount: null,
        },
        pendingTransactions: [],
        technicianAccounts: [],
        isLoading: false,
        invoices: [],
        bill: null,
        totalAmountToInvoice: null,
        showAlert: true
    }
}

const state = {
    formData: {
        transactions: [],
        cbu: "",
        invoice: null,
        date: null,
        invoiceNumber: null,
        cuit: null,
        amount: null,
    },
    pendingTransactions: [],
    technicianAccounts: [],
    isLoading: false,
    invoices: [],
    bill: null,
    totalAmountToInvoice: null,
    showAlert: true
}

const getters = {
    getBillById: state => id => {
        return state.invoices.find(invoice => invoice.id === id)
    },
    formDataTransactions: state => {
        if (state.formData && state.formData.transactions) return state.formData.transactions
        return []
    }
}

const actions = {
    getBills({ commit }) {
        const url = `${baseApiUrl}invoice/`
        axios.get(url)
            .then(({ data }) => {
                commit('setInvoices', data)
            })
            .catch((error) => {
                throw new Error("Error al cargar las facturas");
            });
    },
    getTotalAmount({ commit, state }) {
        const url = `${baseApiUrl}pending_transactions/get_total_amount`

        axios
            .get(url)
            .then(({ data }) => {
                const totalAmount = data.total_amount
                commit('setTotalAmountToInvoice', totalAmount)
            })
            .catch((error) => {
                throw new Error(
                    "Error al cargar el monto total de las facturas pendientes"
                );
            });
    },
    getBillDetail({ commit, getters, state }, id) {
        if (state.bill?.id === id) {
            return state.bill
        }

        const bill = getters.getBillById(id)

        if (bill) {
            commit('setBill', bill)
            return bill
        } else {
            const url = `${baseApiUrl}invoice/${id}/`
            return axios.get(url).then(({ data }) => {
                commit('setBill', data)
                return data
            })
        }
    },
    async getPendingTransactions({ commit, state }) {
        const url = `${baseApiUrl}pending_transactions/`

        commit('setIsLoading', true)
        axios.get(url).then(({ data }) => {
            commit('setPendingTransactions', data)
        }).catch((error) => {
            console.log({ error })
            throw new Error('Error al cargar las transacciones')
        }).finally(() => {
            commit('setIsLoading', false)
        })
    },
    async getTechnicianAccounts({ commit, state }) {
        const url = `${baseApiUrl}datos_facturacion/`

        commit('setIsLoading', true)
        axios.get(url).then(({ data }) => {
            commit('setTechnicianAccounts', data)
        }).catch((error) => {
            console.log({ error })
            throw new Error('Error al cargar las cuentas del técnico')
        }).finally(() => {
            commit('setIsLoading', false)
        })
    },
    async sendInvoice(context, newInvoice) {
        const url = `${baseApiUrl}invoice/`
        try {
            await axios.post(url, newInvoice, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
        } catch (error) {
            throw error
        }
    },
    handleFormDataChanges({ commit, state, getters }, newData) {
        commit('setFormData', newData)
    },
    setInvoiceFile({ commit, state }, file) {
        const newInvoice = {
            ...state.formData,
            invoice: file
        }

        commit('setFormData', newInvoice)
    },
    hideBillAlert({ commit }) {
        commit('setShowAlert', false)
    }
}

const mutations = {
    setFormData: (state, payload) => (state.formData = payload),
    setIsLoading: (state, payload) => (state.isLoading = payload),
    setPendingTransactions: (state, payload) => (state.pendingTransactions = payload),
    setTechnicianAccounts: (state, payload) => (state.technicianAccounts = payload),
    setInvoices: (state, payload) => (state.invoices = payload),
    setBill: (state, payload) => (state.bill = payload),
    setTotalAmountToInvoice: (state, payload) => (state.totalAmountToInvoice = payload),
    setShowAlert: (state, payload) => (state.showAlert = payload),
    setState: (state) => {
        Object.assign(state, defaultState())
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
